<template>
    <main>
        <simple-dropdown ref="dropdown">
            <template #trigger>
                <button class="flex items-center rounded-32 border border-primary-20 h-40 hover:border-primary-80 trans-ease">
                    <avatar
                        :image="selectedUser ? selectedUser.image_url : undefined"
                        :color="selectedUser ? undefined : styles.colors.primary['60']"
                        size="small"
                        class="mr-8 ml-px"
                    >
                        <svg-icon v-if="!selectedUser" type="person"></svg-icon>
                        <span v-else>{{ selectedUser.initials }}</span>
                    </avatar>
                    <span class="mr-12">
                        <span v-if="selectedUser">{{ selectedUser.name }}</span>
                        <span v-else class="text-primary-60">{{ $t('tasks.unassigned') }}</span>
                    </span>
                    <button v-if="selectedUser" @click.stop="unselectUser" class="group">
                        <svg-icon type="cancel" class="max-w-16 max-h-16 text-primary-80 group-hover:text-semantic-error trans-ease mr-12"></svg-icon>
                    </button>
                </button>
            </template>
            <template #content="{ close }">
                <div class="min-w-336">
                    <div class="border-b-2 border-primary-20">
                        <search
                            v-model="search"
                            :placeholder="$t('applications.search_by_name')"
                            autofocus
                            no-icon
                            @keydown.up.prevent="highlightPrevious"
                            @keydown.down.prevent="highlightNext"
                            @keydown.enter.prevent="selectHighlighted"
                        />
                    </div>
                    <div>
                        <ul v-show="filteredUsers.length" class="max-h-200 overflow-y-scroll">
                            <li
                                v-for="(user, index) in filteredUsers"
                                :key="'user-selector-' + user.id"
                                class="flex items-center px-12 py-8 cursor-pointer"
                                :class="(user.id == value) || ( index == highlightedUser) ? 'bg-primary-20' : ''"
                                @click="selectUser(user.id)"
                                @mouseover="highlight(index)"
                            >
                                <avatar
                                    :image="user.image_url"
                                    size="small"
                                    class="mr-8"
                                >{{ user.initials }}</avatar>
                                <span class="mr-auto mr-12">{{ user.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
        </simple-dropdown>
    </main>
</template>

<script>
import SimpleDropdown from './SimpleDropdown.vue';
import Avatar from './Avatar.vue';
import styles from '../../../../../../styles.config';
import SvgIcon from './SvgIcon.vue';
import { mapState, mapActions } from 'pinia';
import {useRepo} from 'pinia-orm';
import {useAuthenticationStore} from '../../state/modules/authentication';
import {useUsersStore} from '../../state/modules/users';
import User from '../../models/User';
import Input from '../forms/Input.vue';
import Search from "./Search.vue";

export default {
    components: {
        Search,
        'simple-dropdown': SimpleDropdown,
        'avatar': Avatar,
        'svg-icon': SvgIcon,
        'simple-input': Input,
    },
    props: {
        value: Number,
    },
    data: function () {
        return {
            styles,
            search: '',
            highlightedUser: null,
        }
    },
    computed: {
        ...mapState(useAuthenticationStore, ['currentCompanyId', 'currentUserId']),
        users () {
            return useRepo(User).whereHas('companies', query => query.whereId(this.currentCompanyId)).get();
        },
        filteredUsers () {
            return this.users.filter(user => user.name.toLowerCase().includes(this.search.toLowerCase()));
        },
        selectedUser () {
            return this.users.find(user => user.id == this.value);
        }
    },
    methods: {
        ...mapActions(useUsersStore, ['fetchUsers']),
        selectUser (userId) {
            this.$emit('input', userId);
            this.$refs.dropdown.close();
            this.search = '';
        },
        unselectUser () {
            this.$emit('input', undefined);
            this.$refs.dropdown.close();
            this.search = '';
        },
        highlight (index) {
            this.highlightedUser = index;
        },
        highlightNext () {
            if (this.highlightedUser + 1 >= this.filteredUsers.length) {
                this.highlightedUser = 0;
            } else {
                this.highlightedUser += 1;
            }
        },
        highlightPrevious () {
            if (this.highlightedUser - 1 < 0) {
                this.highlightedUser = this.filteredUsers.length - 1;
            } else {
                this.highlightedUser -= 1;
            }
        },
        selectHighlighted () {
            this.selectUser(this.filteredUsers[this.highlightedUser].id);
        }
    },
    mounted () {
        this.fetchUsers();
    }
}
</script>
